import { render, staticRenderFns } from "./ItemizeItinerary.vue?vue&type=template&id=3579f886"
import script from "./ItemizeItinerary.vue?vue&type=script&lang=js"
export * from "./ItemizeItinerary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports